import { useLogoutQuery } from '../../api/user.js';
import Splash from '../../components/layout/Splash.jsx';

const Logout = () => {
    const mfaIdentifier = localStorage.getItem('mfaIdentifier');

    useLogoutQuery({
        ...(mfaIdentifier && { identifier: mfaIdentifier })
    });

    return <Splash />;
};

export default Logout;
